import { module } from 'modujs';
import { gsap } from 'gsap' ;

export default class extends module {
    constructor(m) {
        super(m);

		if(!window.isMobile) {
			this.events = {
				mouseenter: {
					zone: 'enter'
				},
				mouseleave: {
					zone: 'leave'
				},
				mousemove: {
					zone: 'move'
				}
			}
		}
		this.isDisplayed = false;
		this.id = this.el.getAttribute('data-module-cursor-zone');

		this.$zone = this.$('zone')[0];
    }

    init() {
		this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);
    }

	ready() {
		this.resize();

		gsap.delayedCall(6,() => {
			this.resize();
		});
		gsap.delayedCall(10,() => {
			this.resize();
		});
	}

	enter() {
		this.isDisplayed = true;

		this.call('display',{},'Cursor',this.id)
	}

	move(e) {		
		if(!this.isDisplayed) {
			this.enter();
		}
	}

	leave() {
		this.call('hide',{},'Cursor',this.id)
	}

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		this.bcr = this.$zone.getBoundingClientRect();

		if(!window.isMobile) {
			this.call('updateOffset',this.bcr,'Cursor',this.id)
		}

	}

	destroy() {
		window.removeEventListener("resize", this.bindResize);

	}
}

